import React from "react";
import "../styles/InfoDocumentos.css";
import { useAuth } from "../context/AuthContext.jsx";
import FileManager from "./FileManager.jsx";
import { FileSignature } from 'lucide-react'; // Mismo ícono que en Gobierno

const InfoResoluciones = () => {
  const { isAdmin } = useAuth();
  return (
      <div className="doc-page-container" style={{'--doc-color': '#17a589', '--doc-bg-color': '#f0fcf9'}}>
        <div className="doc-page-card">
          <div className="doc-page-header">
            <div className="doc-page-icon"><FileSignature size={48} /></div>
            <h2 className="doc-page-title">Resoluciones</h2>
          </div>
          <p className="doc-page-text">
            Desde la <strong>Comuna de Santo Domingo</strong>, ponemos a disposición las resoluciones comunales para su consulta pública.
          </p>
          <FileManager
              tableName="resoluciones_files"
              folderName="resoluciones"
              bucketName="resoluciones"
              isAdmin={isAdmin}
          />
          <div className="doc-page-footer"><p>Para consultas técnicas, acercarse a la oficina comunal.</p></div>
        </div>
      </div>
  );
};
export default InfoResoluciones;